import { useNavigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

/**
 * Clickable deal name that navigates to /deal/:id.
 * Passes the current path as `state.from` so DealDetail can
 * navigate back to exactly where the user came from.
 *
 * Usage:
 *   <DealLink id={d.id}>{d.homeowner_name ?? "(no name)"}</DealLink>
 */
export default function DealLink({
  id,
  children,
  className = "",
}: {
  id: string;
  children: ReactNode;
  className?: string;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.pathname + location.search;
  return (
    <span
      role="link"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/deal/${id}`, { state: { from } });
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") navigate(`/deal/${id}`, { state: { from } });
      }}
      className={
        "cursor-pointer hover:underline text-bardin-teal " + className
      }
    >
      {children}
    </span>
  );
}
